module.exports = __webpack_public_path__ + "static/img/2021-B.698721d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2021-B.png
// module id = NC/G
// module chunks = 1